import { render, staticRenderFns } from "./InboxAttachment.vue?vue&type=template&id=203dfba5"
import script from "./InboxAttachment.vue?vue&type=script&lang=js"
export * from "./InboxAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports